<script lang="ts" setup>
import type { IProps } from './MultiuczynekItems.types'
import MultiuczynekItem from './MultiuczynekItem.vue'

defineProps<IProps>()

</script>

<template>
  <div class="multiuczynek-items__wrapper">
    <div class="multiuczynek-items">
      <MultiuczynekItem
        v-for="(item, index) in items"
        :key="`multiuczynek-item-${index}`"
        :item="item"
      />
    </div>

    <h3
      class="multiuczynek-items__text"
      v-html="$t('keyActivities.multiuczynek.text')"
    />
  </div>
</template>

<style lang="scss" scoped>
.multiuczynek-items {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 5.6rem;
  margin-bottom: 4rem;
  background-color: $white;

  &__wrapper {
    padding: 2.4rem;
    background-color: $white;
    border-radius: 1.6rem;
  }

  &__text {
    @include h8;
    color: #F8902C;
    text-align: center;
    
    :deep(br) {
      display: none;
    }
  }
}

@include atM {
  .multiuczynek-items {
    flex-wrap: nowrap;
    margin-bottom: 7.2rem;

    &__wrapper {
      padding: 6.4rem 14.4rem 8.8rem;
    }

    &__text {
      @include h7;
      
      :deep(br) {
        display: inline;
      }
    }
  }
}
</style>
